module.exports = __webpack_public_path__ + "static/rocketlinkint-4c19aba4d0b4bcae16ccd3cd3ee110b5.png";